import { each, isNil, getEllipsisText, pick } from '@antv/util';
import { ellipsisString, strLen } from './text';
var ELLIPSIS_CODE = '\u2026';
var ELLIPSIS_CODE_LENGTH = 2; // çç¥å·çé¿åº¦
/** å¤§æ°æ®ééå¼ */
var OPTIMIZE_THRESHOLD = 400;
/**
 * éå¯¹å¤§æ°æ®éåä¼åç getMaxLabelWidthï¼åæ³ä¸æ¯ç´æ¥å»æ¯è¾æ¯ä¸ä¸ª label çæå¤§å®½åº¦
 * èæ¯åéè¿æ¯è¾æ¯ä¸ª label æ¯ä¸ªçå­ç¬¦ä¸²çé¿åº¦ï¼è¿éåºåäºä¸ä¸­è±æå­ç¬¦
 * æç»æ¯å»å­ç¬¦ä¸²æâé¿âçé£ä¸ª label çå®½åº¦ã
 * @param labels
 */
function getMaxLabelWidthOptimized(labels) {
    var texts = labels.map(function (label) {
        var text = label.attr('text');
        return isNil(text) ? '' : "" + text;
    });
    var maxLen = 0;
    var maxIdx = 0;
    for (var i = 0; i < texts.length; i += 1) {
        var len = 0;
        for (var j = 0; j <= texts[i].length; j += 1) {
            var code = texts[i].charCodeAt(j);
            if (code >= 19968 && code <= 40869) {
                len += 2;
            }
            else {
                len += 1;
            }
        }
        if (len > maxLen) {
            maxLen = len;
            maxIdx = i;
        }
    }
    return labels[maxIdx].getBBox().width;
}
/** è·åæé¿ç label */
export function getMaxLabelWidth(labels) {
    if (labels.length > OPTIMIZE_THRESHOLD) {
        return getMaxLabelWidthOptimized(labels);
    }
    var max = 0;
    each(labels, function (label) {
        var bbox = label.getBBox();
        var width = bbox.width;
        if (max < width) {
            max = width;
        }
    });
    return max;
}
/** è·ålabelé¿åº¦ */
export function getLabelLength(isVertical, label) {
    var bbox = label.getCanvasBBox();
    return isVertical ? bbox.width : bbox.height;
}
/* labelé¿åº¦æ¯å¦è¶è¿çº¦æå¼ */
export function testLabel(label, limitLength) {
    return label.getBBox().width < limitLength;
}
/** å¤ç text shape çèªå¨çç¥ */
export function ellipsisLabel(isVertical, label, limitLength, position) {
    var _a;
    if (position === void 0) { position = 'tail'; }
    var text = (_a = label.attr('text')) !== null && _a !== void 0 ? _a : ''; // é¿ååºç°nullãundefined
    if (position === 'tail') {
        // component éçç¼©ç¥å¤çåå¾å¾ç³ç³ï¼æå­é¿åº¦æµç®å®å¨ä¸åç¡®
        // è¿éææ¶åªå¯¹ tail åå¤ç
        var font = pick(label.attr(), ['fontSize', 'fontFamily', 'fontWeight', 'fontStyle', 'fontVariant']);
        var ellipsisText = getEllipsisText(text, limitLength, font, 'â¦');
        if (text !== ellipsisText) {
            label.attr('text', ellipsisText);
            label.set('tip', text);
            return true;
        }
        label.set('tip', null);
        return false;
    }
    var labelLength = getLabelLength(isVertical, label);
    var codeLength = strLen(text);
    var ellipsisFlag = false;
    if (limitLength < labelLength) {
        var reserveLength = Math.floor((limitLength / labelLength) * codeLength) - ELLIPSIS_CODE_LENGTH; // è®¡ç®åºæ¥çåºè¯¥ä¿å­çé¿åº¦
        var newText = void 0;
        if (reserveLength >= 0) {
            newText = ellipsisString(text, reserveLength, position);
        }
        else {
            newText = ELLIPSIS_CODE;
        }
        if (newText) {
            label.attr('text', newText);
            ellipsisFlag = true;
        }
    }
    if (ellipsisFlag) {
        label.set('tip', text);
    }
    else {
        label.set('tip', null);
    }
    return ellipsisFlag;
}
//# sourceMappingURL=label.js.map